<!-- Toast notifications -->
<p-toast key="main"></p-toast>

<p-contextMenu #cm [model]="menuItems" appendTo="body"></p-contextMenu>

<!-- Modern Header Section -->
<div class="m-4">
  <div class="clinic-products-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="clinic-products-title">
          <i class="pi pi-box mr-3"></i>
          Clinic Products
        </h1>
        <p class="clinic-products-subtitle">
          Manage and view products available for all clinics
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="clinic-products-content">
  <div class="content-section">
    <div class="section-header">
      <div class="header-info">
        <h2 class="section-title">Product Management</h2>
        <p class="section-description">
          View and manage the current products available for your clinic
        </p>
      </div>
    </div>

    <div class="content-header">
      <div class="header-info">
        <h2 class="section-title"></h2>
        
      </div>
      <div *ngIf="userRole === 'zpl-clinic-admin'" class="header-actions mr-4">
        <button
          pButton
          pRipple
          label="Create Product"
          icon="pi pi-plus"
          class="modern-button primary ml-4"
          (click)="openCreateProductDialog()"
        ></button> 
      </div>
    </div>

    <div class="table-container p-4">
      <p-table
        #productsTable
        [value]="clinicProducts"
        [lazy]="true"
        [rows]="10"
        [paginator]="true"
        (onLazyLoad)="loadProductsLazy($event)"
        [scrollable]="true"
        scrollHeight="50vh"
        [totalRecords]="metaData.totalRecords"
        class="modern-table"
        [showCurrentPageReport]="true"
        [(first)]="metaData.offset"
        [(rows)]="metaData.limit"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [loading]="metaData.loading"  
        [(contextMenuSelection)]="selectedRow"
        [contextMenu]="cm"
      >
        <ng-template pTemplate="caption">
          <div class="">
            <div>
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                name="globalFilter"
                (input)="
                  productsTable.filterGlobal(
                    getFilterInputValue($event),
                    'contains'
                  )
                "
                placeholder="Search products..."
                class=""
              />
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr class="table-header">
            <th
              *ngFor="let col of productColumns"
              [pSortableColumn]="col.field"
            >
              <div class="header-cell">
                {{ col.header }}
              </div>
            </th>
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-products>
          <tr class="table-row" [pContextMenuRow]="products" style="cursor: pointer">
            <td *ngFor="let col of productColumns" class="table-cell">

              <!-- if value is status change to enables/disabled with styling -->


              <div class="cell-content">
                <span *ngIf="col.field == 'is_active'">
                  <span
                    [ngClass]="{
                      'status-badge enabled': products.is_active,
                      'status-badge disabled': !products.is_active
                    }"
                    [style.background]="products.is_active ? 'linear-gradient(135deg, rgba(34, 197, 94, 0.2) 0%, rgba(22, 163, 74, 0.2) 100%)' : 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(220, 38, 38, 0.2) 100%)'"
                    [style.color]="products.is_active ? '#15803d' : '#dc2626'"
                    [style.border]="products.is_active ? '2px solid rgba(34, 197, 94, 0.3)' : '2px solid rgba(239, 68, 68, 0.3)'"
                    [style.padding]="'0.5rem 1rem'"
                    [style.borderRadius]="'20px'"
                    [style.fontSize]="'0.75rem'"
                    [style.fontWeight]="'700'"
                    [style.textTransform]="'uppercase'"
                    [style.letterSpacing]="'0.5px'"
                    [style.display]="'inline-flex'"
                    [style.alignItems]="'center'"
                    [style.justifyContent]="'center'"
                    [style.minWidth]="'80px'"
                    [style.textAlign]="'center'"
                    [style.boxShadow]="products.is_active ? '0 2px 8px rgba(34, 197, 94, 0.2)' : '0 2px 8px rgba(239, 68, 68, 0.2)'"
                  >
                    {{ products.is_active ? 'Enabled' : 'Disabled' }}
                  </span>
                </span>
              
                <span *ngIf="col.field != 'is_active'" class="cell-text">{{ products[col.field] }}</span>
              </div>
            </td>
            <td>
              <button
                pButton
                pRipple
                icon="pi pi-ellipsis-v"
                class="p-button-rounded p-button-text"
                (click)="showContextMenu($event, products)"
              ></button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="productColumns.length" class="empty-state">
              <p-progressBar
                *ngIf="metaData.loading"
                mode="indeterminate"
              ></p-progressBar>
              <div *ngIf="!metaData.loading" class="empty-content">
                <i class="pi pi-box empty-icon"></i>
                <h3>No products found</h3>
                <p>No products are currently available for your clinic</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog header="Toggle" key="productToggle"></p-confirmDialog>
